import { useAuth } from '../../contexts/AuthContext'

export default function TeamMemberBanner() {
  const { accountType, adminDisplayName } = useAuth()
  if (accountType !== 'team_member') return null
  const adminName = adminDisplayName ?? 'your admin'
  return (
    <div className="bg-violet-500/10 border-b border-violet-500/20 px-4 py-2">
      <div className="text-xs text-violet-200 text-center">
        Viewing <span className="font-medium">{adminName}</span>&rsquo;s GraspPod
        {' '}— Team Member access
      </div>
    </div>
  )
}
